import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/core/service/notifications/notification.service';
import { TicketService } from 'src/app/core/service/tickets/tickets.service';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit {

  currentStep = '';
  selectedNumbers: number[] = [];
  votedTicketNumbers: number[] = [];

  constructor(private ticketService: TicketService, private router: Router, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.currentStep = 'selectNumbers';

    this.ticketService.playPeriod$.subscribe(playPeriod => {
      const allowUserPurchase = playPeriod?.allowUserPurchase ?? false;
      if (!allowUserPurchase) {
        this.router.navigateByUrl('')
        this.notificationService.showError('You have already played for this round.');
      }
    })
  }

  isTabActive(tab: string): boolean {
    return this.currentStep === tab;
  }

  setActiveTab(tab: string): void {
    this.currentStep = tab;
  }

  onSelectNumbersNext(selectedNumbers: number[]): void {
    this.currentStep = 'voteTicket';
    this.selectedNumbers = selectedNumbers;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onVoteTicketNext(votedTicket: any): void {
    this.currentStep = 'checkout';
    this.votedTicketNumbers = votedTicket;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCheckoutConfirm(data: any): void {
    console.log('Checkout completato', data);
  }



}
